/**
 * Maps the current hostname to a chatbot site_key that selects
 * the right assistant profile from chatbot_settings.
 */
export function getSiteKey(): string {
  if (typeof window === 'undefined') return 'nomad-fest';
  const host = window.location.hostname.toLowerCase();
  if (host.includes('silvernomadz')) return 'silvernomadz';
  if (host.includes('colivingadrenalin')) return 'coliving-adrenalin';
  if (host.includes('family-hostel')) return 'family-hostel';
  // nomad-fest.com, lovable preview, localhost → nomad-fest
  return 'nomad-fest';
}